import React, { useEffect, useRef, useState } from 'react';
import MissionList from '../helpers/missionList';
import anaSayfa from "../assets/home.png";
import '../styles/Home.css';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const aboutRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      const top = aboutRef.current.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      if (top < windowHeight - 100) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="home">
        <video autoPlay muted loop playsInline className="bg-video">
          <source src="/home1.mp4" type="video/mp4" />
        </video>
        <div className="overlay"></div>
        <div className="headerContainer">
         
        </div>
      </div>

      <div
        className={`aboutSection scroll-animate ${isVisible ? 'visible' : ''}`}
        ref={aboutRef}
      >
        <div className="aboutContent">
          <div className="aboutText">
            <h2>{t('home.whoAreWe')}</h2>
            <p>{t('home.desc1')}</p>
            <p>{t('home.desc2')}</p>
            <button className="readMoreBtn" onClick={() => window.location.href = "/hakkimizda"}>
              {t('home.readMore')}
            </button>
          </div>
          <div className="aboutImage">
            <img src={anaSayfa} alt="Anchmar Yat Görseli" />
          </div>
        </div>
      </div>

      <MissionList />
    </>
  );
};

export default Home;